export class CatalagosConfig {
    TipoEvento: CatProps = { tblName: 'socorros_tipo_evento', label: 'Tipo de evento' }; //2022-03-12 (aaangeles)
    TipoDomicilio: CatProps = { tblName: 'socorros_tipo_domicilio', label: 'Tipo de domicilio' }; //2022-03-12 (aaangeles)
    TipoUnidad: CatProps = { tblName: 'transportes_tipo_unidad', label: 'Tipo de unidad'}; //2022-03-12 (aaangeles)
    Contacto: CatProps = { tblName: 'socorros_contacto', label: '' };
    Institucion: CatProps = {tblName: 'socorros_institucion', label: 'Institución'};
    TipoPago: CatProps = {tblName: 'socorros_tipo_pago', label: 'Tipo de pago'}; //2022-03-12 (aaangeles)
    ColocacionUnidad: CatProps = {tblName: 'socorros_colocacion_unidad', label: 'Colocacion Unidad'};
    Unidad: CatProps = {tblName: 'transportes_unidad', label: 'Transportes Unidad'};
    Operador: CatProps = {tblName: 'transportes_unidad', label: 'Transportes Unidad'};
    NoUnidad: CatProps = {tblName: 'transportes_unidad_2', label: 'No. Unidad'};
    TipoPrestador: CatProps = {tblName: 'socorros_tipo_prestador', label: 'Tipo Clasificación'};

    
    
    Personal: CatProps = {tblName: 'personal_personal', label: 'Personal'};
    Responsable: CatProps = {tblName: 'personal_personal_correo', label: 'Nombre responsable'};
    PersonalRol: CatProps = {tblName: 'personal_perfil', label: 'Rol'};
    PersonalPuesto: CatProps = {tblName: 'personal_rol', label: 'Puesto'};
    PersonalTurno: CatProps = {tblName: 'personal_turno', label: 'Turno'};
    PersonalEspecialidad: CatProps = {tblName: 'personal_especialidad', label: 'Especialidad'};
    PersonalNivelTUM: CatProps = {tblName: 'personal_nivel_tum', label: 'Nivel de TUM'};
    PersonalEscolaridad: CatProps = {tblName: 'personal_escolaridad', label: 'Escolaridad'};
    PersonalAnexo: CatProps = {tblName: 'socorros_tipo_prestador', label: 'Clasificación personal anexo'};
    PersonalRemunerado: CatProps = {tblName: 'personal_remunerado', label: 'Personal'};
    
    
    
    GeneralEstado: CatProps = {tblName: 'general_estado', label: 'General Estado'};
    GeneralMunicipio: CatProps = {tblName: 'general_municipio', label: 'General Municipio'};
    GeneralPais: CatProps = { tblName: 'general_pais', label: 'País' };
    GeneralArea: CatProps = { tblName: 'general_base', label: 'Base' };
    GeneralBase3: CatProps = { tblName: 'general_base3', label: 'Base' };
    General_Area: CatProps = { tblName: 'general_area', label: 'Área' };
    GeneralDepartamento: CatProps = { tblName: 'general_departamento', label: 'Departamento' };
    GeneralClase: CatProps = { tblName: 'general_clase_licencia', label: 'Clase' };
    GeneralDelegacion: CatProps = { tblName: 'general_delegacion', label: 'Delegación' };
    
    TipoServicio: CatProps = { tblName: 'transportes_tipo_servicio', label: 'Tipo Servicio' };
    Sistema: CatProps = { tblName: 'transportes_sistema', label: 'Sistema' };
    Componente: CatProps = { tblName: 'transportes_componente_p', label: 'Componente' };
    Accion: CatProps = { tblName: 'transportes_accion', label: 'Acción' };
    Refaccion: CatProps = { tblName: 'transportes_refaccion', label: 'Refacción' };


    MarcaUnidad: CatProps = { tblName: 'transportes_marca_unidad', label: 'Marca'};
    Transmision: CatProps = { tblName: 'transportes_transmision', label: 'Transmisión' };
    TipoCombustible: CatProps = { tblName: 'transportes_tipo_combustible', label: 'Tipo de combustible' };
    ModeloUnidad: CatProps = { tblName: 'transportes_modelo_unidad', label: 'Modelo' };
    EstatusUnidad: CatProps = { tblName: 'transportes_estatus', label: 'Estatus' };
    NivelUnidad: CatProps = { tblName: 'transportes_unidad_nivel', label: 'Nivel de atención' };
    CondicionUnidad: CatProps = { tblName: 'transportes_unidad_condicion', label: 'Estado físico' };
    ColorUnidad: CatProps = { tblName: 'transportes_unidad_color', label: 'Color' };
    UsoUnidad: CatProps = { tblName: 'transportes_uso_unidad', label: 'Uso' };
    FormaAdquisionUnidad: CatProps = {tblName: 'transportes_unidad_forma_adquisicion', label: 'Forma de adquisición'}
    AseguradoraUnidad:CatProps ={tblName:'transportes_poliza_aseguradora',label:'Aseguradora'}
    TipoCobertura:CatProps={tblName:'transportes_poliza_tipo_cobertura',label:'Tipo de cobertura'}
    TipoMtto:CatProps={tblName:'transportes_tipo_mtto',label:'Tipo Mtto'}
    InstitucionDerechohabiente: CatProps={ tblName: 'paramedico_institucion_derechohabiente', label: 'Institución' };
    CompaniaSeguro: CatProps={ tblName: 'paramedico_compania_seguro', label: 'Compañía seguros' };
    CompaniaGastosMedicos: CatProps={ tblName: 'paramedico_compania_gastos_medicos', label: 'Compañía gastos médicos' };
    MotivoNoEfectivo: CatProps = { tblName: 'paramedico_frap_motivo_no_efectivo', label: 'Motivo' };
    InstitucionTraslado : CatProps = { tblName: 'paramedico_institucion_traslado', label: 'Institución traslado '};
    MaterialUtilizado : CatProps = { tblName: 'abastecimiento_material', label: 'Institución traslado' };
    Material : CatProps = { tblName: 'abastecimiento_material', label: 'Material' };

    Proveedor: CatProps = { tblName: 'transportes_proveedor', label: 'Proveedor'};
    Factura: CatProps = { tblName: 'transportes_marca_unidad', label: 'Marca Unidad'};
    EstatusTaller: CatProps = { tblName: 'transportes_estatus_taller', label: 'Estatus taller'};
    Servicio: CatProps = { tblName: 'transportes_servicio', label: 'Servicio'};
    RazonSocial: CatProps = { tblName: 'general_razon_social', label: 'Razón Social'};
    usoCFDI: CatProps = { tblName: 'general_uso_cfdi', label: 'Uso CFDI'};
    TipoMantenimiento:CatProps={tblName:'transportes_tipo_mantenimiento',label:'Tipo Mtto'}
    Tipo_Mantenimiento:CatProps={tblName:'transportes_subtipo',label:'Tipo Mtto'}
    GeneralMunicipio2: CatProps = {tblName: 'general_municipio_2', label: 'General Municipio'}; /* 2022-02-11 (aaangeles) */
    ProveedorEspecialidad: CatProps = { tblName: 'transportes_proveedor_especialidad', label: 'Especialidad'}; /* 2022-02-20 (aaangeles) */
    
    PacienteParentesco : CatProps = {tblName : 'socorros_paciente_parentesco', label : 'Parentesco'}; //jmartin 14/03/2022
    PacienteOrigenLlamada : CatProps = {tblName : 'socorros_origen_llamada', label : 'Origen Llamada'}; //jmartin 14/03/2022
    SocorrosEmpresa : CatProps = {tblName : 'socorros_empresa', label : 'Empresa'}; //jmartin 14/03/2022
    SocorrosTipoProblematica : CatProps = {tblName : 'socorros_tipo_problematica', label : 'Tipo Problemática'}; //jmartin 14/03/2022
    SocorrosClaveServicio : CatProps = {tblName : 'socorros_clave_servicio', label : 'Código del servicio'}; //jmartin 14/03/2022

    Agrupador : CatProps = {tblName : 'paramedico_checklist_cat_agrupador', label : 'Agrupador'};

    CheckIncidencia : CatProps = {tblName : 'socorros_checklist_cat_tipo_incidencia', label : 'Tipo Incidencia'};

    PuntoRevision : CatProps = {tblName : 'transportes_checklist_cat_puntos_revision', label : 'Punto de revisión'};
    Categoria : CatProps = {tblName : 'transportes_checklist_cat_categoria', label : 'Categoría'};

    PlaneacionIncidencia : CatProps = {tblName: 'planeacion_incidencias', label : 'Planeación Permisos'}

    /* Control de inventario */
    TipoMaterial            : CatProps = {tblName : 'abastecimiento_cat_tipo_material', label : 'Tipo de material'}
    UnidadMedida            : CatProps = {tblName : 'abastecimiento_cat_um', label : 'Unidad de medida'}
    TipoUrgencia            : CatProps = {tblName : 'abastecimiento_cat_tipo_urgencia', label : 'Tipo de urgencia'}
    Nivel                   : CatProps = {tblName : 'abastecimiento_cat_nivel', label : 'Nivel'}

    /*  Transportes Siniestro   */
    SiniestroCausa          : CatProps = {tblName : 'transportes_siniestro_causa', label : 'Causa Raíz'};
    SiniestroTipo           : CatProps = {tblName: 'transportes_tipo_siniestro', label : 'Tipo de siniestro'};
}
interface CatProps {
    tblName: string;
    label: string;
}

export interface ICatValues{
    id:number,
    value:string
}